import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class AdminDashboardController extends Controller {
  // Services
  @service headData;
  @service intl;
  @service permission;

  // Actions
  setHeadData = () => {
    this.headData.title = this.intl.t('dashboard.title');
    this.headData.favicon = 'dashboard';
  };
}
